import './MultipleTabsBlockedScreen.css';

/**
 * Tela exibida quando detecta que o usuário já está conectado em outra aba
 */
export default function MultipleTabsBlockedScreen() {
  return (
    <div className="multiple-tabs-blocked-container">
      <div className="multiple-tabs-blocked-content">
        <div className="multiple-tabs-blocked-icon">⚠️</div>
        <h1 className="multiple-tabs-blocked-title">
          Você já está conectado em outra aba
        </h1>
        <p className="multiple-tabs-blocked-message">
          Por favor, feche esta aba e use apenas uma aba para acessar a aplicação.
        </p>
        <p className="multiple-tabs-blocked-hint">
          Se você fechou a outra aba, recarregue esta página.
        </p>
      </div>
    </div>
  );
}

